import { render, staticRenderFns } from "./OnlineClasses.vue?vue&type=template&id=3490ac22&scoped=true&"
import script from "./OnlineClasses.vue?vue&type=script&lang=js&"
export * from "./OnlineClasses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490ac22",
  null
  
)

export default component.exports